import type { PropsWithChildren } from 'react';
import type React from 'react';

import type { MembershipBottomBannerData } from '#src/app/shared/api/membership';

import { MembershipBottomBannerDataContext } from './context';

export const MembershipBottomBannerDataProvider: React.FC<PropsWithChildren<{ data: MembershipBottomBannerData }>> = ({
	children,
	data,
}) => {
	return (
		<MembershipBottomBannerDataContext.Provider value={data}>{children}</MembershipBottomBannerDataContext.Provider>
	);
};
